import { useState } from 'react'
import Table from '@mui/material/Table'
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';
import TableTitle from './TableTitle'
import TableSortFooter from './TableSortFooter'
import TableSortHeader from './TableSortHeader';
import TableNoSortHeader from './TableNoSortHeader';
import TableSortBody from './TableSortBody';
import TableNoSortBody from './TableNoSortBody';

export default function TableSort(props) { 
  const { heads, tabledata, titleText, footerText, columnOrder=null, doNotSort=false, tableNoSortData=null } = props;
  const numCols = columnOrder ? columnOrder.filter((column) => !column.invisible).length : heads.filter((column) => !column.invisible).length;
  const sortColumn = heads.flat().filter((column) => column.initSort);
  const [ orderBy, setOrderby ] = useState(sortColumn.length > 0 ? sortColumn[0].id : heads[0].id);
  const [ order, setOrder ] = useState(sortColumn.length ? sortColumn[0].sortOrder : 'asc');

  const handleRequestSort = (property) => {
    if (!doNotSort) {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderby(property);
    }
  }

  return (
    <>
      {titleText &&
        <TableTitle 
         titleText={titleText} 
        />
      }
      <TableContainer>
        <Table style={{tableLayout: "fixed"}}>
          {heads && tabledata &&
            <TableSortHeader
              heads={heads}
              order={order}
              orderBy={orderBy}
              handleRequestSort={handleRequestSort}
              doNotSort={doNotSort}
            />
          }
          {heads && !tabledata && tableNoSortData &&
            <TableNoSortHeader
              heads={heads}
            />
          }
          {tabledata &&
            <TableSortBody
              tabledata={tabledata}
              cheads={columnOrder || heads}
              order={order}
              orderBy={orderBy}
            />
          }
          {tableNoSortData &&
            <TableNoSortBody
              tabledata={tableNoSortData}
              cheads={columnOrder || heads}
            />
          }
          {footerText &&
            <TableSortFooter
              colspan={numCols}
              footerText={footerText}
            />
          }
        </Table>
      </TableContainer>
    </>
  )
}